<template>
    <ModalComponent
        :name="'aviso-plazo-' + plazo_id"
        :title="sonAbonos ? 'Enviar avisos para dar de baja el abono por plazos impagados fallidos definitivos' : 'Enviar aviso de plazo impagado por fallidos definitivos'"
        v-on:close="close"
    >
        <ContentAvisos @terminar="terminar" :loading="loading" :sonAbonos="sonAbonos" @close="close"/>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import ContentAvisos from "./components/ContentAvisos";

    export default {
        props: ['plazo_id', 'loading', 'sonAbonos'],
        methods: {
            close() {
                this.$emit('close', 'plazo-' + this.plazo_id);
            },
            terminar() {
                this.$emit('terminado');
            }
        },
        components: {
            ModalComponent, ContentAvisos
        }
    }
</script>
